import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
    tag: {
        "--tag-color": "#94a3b8",
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "1px 5px",
        borderRadius: 5,
        border: "1px solid #d7dde3",
        backgroundColor: "#f4f7f9",
        fontSize: "0.72em",
        fontWeight: 600,
        color: "#2f3a45",
        marginRight: 4,
        marginTop: 2,
        lineHeight: 1.2,
        whiteSpace: "nowrap",
        maxWidth: 150,
        overflow: "hidden",
        textOverflow: "ellipsis",
        textTransform: "none",
        "&:before": {
            content: '""',
            width: 7,
            height: 7,
            borderRadius: 2,
            flex: "0 0 auto",
            backgroundColor: "var(--tag-color)",
        },
    }
}));

const ContactTag = ({ tag }) => {
    const classes = useStyles();

    return (
        <div className={classes.tag} style={{ "--tag-color": tag.color || "#94a3b8" }}>
           {tag.name}
        </div>
    )
}

export default ContactTag;
